export default {
  modalShowing: false,
  modalContent: undefined,
  usersList: {},
  userRoles: {}
}
